import { ConsumableOverviewThemeSizeConfig } from './types';

const large: ConsumableOverviewThemeSizeConfig = {
  consumableOverview: {},
};

export default large;
